import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-66',
  templateUrl: './cards10-examples-66.component.html'
})
export class Cards10Examples66Component {}
